module.exports = __webpack_public_path__ + "static/media/W5390484_25.207688ca.jpg";